import { axiosPrivate } from "../../../api/axios";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";
/**
 * Log events to Klaviyo
 * @param eventName
 * @param eventInfo
 */
export const createKlaviyoEvent = (companyUsesKlaviyo) => (eventName, eventInfo = {}) => {
    if (companyUsesKlaviyo) {
        axiosPrivate.post(`/OrderFlow/ExportKlaviyoEvent?eventName=${eventName}`, eventInfo).catch(() => { });
    }
};
/**
 * Log events to React Pixel
 * @param title
 * @param data
 */
export const logReactPixel = (pixelKey) => (title, data = {}) => {
    if (pixelKey) {
        ReactPixel.trackCustom(title, data);
    }
};
export const logReactPixelPageView = (pixelKey) => () => {
    if (pixelKey) {
        ReactPixel.trackSingle(pixelKey.KeyValue, "PageView");
    }
};
export const gaEvent = (gaKey) => (title, data = {}) => {
    if (gaKey) {
        ReactGA.event(title, data);
    }
};
export const gaPageView = (gaKey) => (page_title, page_location) => {
    if (gaKey) {
        ReactGA.event("page_view", {
            page_title: page_title,
            page_location: page_location,
        });
    }
};
